<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>3rd Party Notes</h3>
        <h4>version : {{version}}</h4>
      </div>
    </div>
  </div>
</div>

<table  class="table table-striped table-bordered mt-3 text-center" style="width:100%" *ngFor="let source of sourceList">
  <thead >
    <tr  class="thead-dark"><th>Data Source: <span class="text-danger text-uppercase">{{source.name}}</span></th></tr>
  </thead>
  <tbody>
    <tr *ngFor="let note of source.notes; index as i">
      <td class="text-left"><span class="font-weight-bold">Note.{{i+1}} : </span> {{note}}</td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td>*** ************************************************************************** ***</td>
    </tr>
    <tr>
      <td>*** -- <span  class="font-italic text-warning font-weight-bold text-uppercase">Special cases aren’t special enough to break the rules.</span>  -- ***</td></tr>
    <tr>
      <td>*** ************************************************************************** ***</td>
    </tr>
  </tfoot>
</table>
